module.exports = __webpack_public_path__ + "static/media/less100-icon.67fe33be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboard/less100-icon.svg
// module id = 2873
// module chunks = 0